import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  IconButton,
} from "@mui/material";
import DangerousRoundedIcon from '@mui/icons-material/DangerousRounded';
// import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import CustomPagination from "../../component/common/CustomPagination";
import EvalJsonDialog from "../EvalJsonDialog";
import EvalTextViewPage from "../EvalTextViewPage";
import EvalTextViewPage_204 from "../EvalTextViewPage_204";


const initailEvknData: any = {
  idx : -1,

  task: "simpleqa",
  data_sources: "",
  category: "",
  subcategory: "",
  bmk_pk: "",
  difficulty: "",
  keyword: "",
  title: "",
  text: "",
  
  qa_type: "",
  answer_type: "",
  science_fact: "",
  common_knowledge: "",
  
  activity: "",
  question_a: "",
  question_b: "",
  question: "",

  answer: "",
  answer_index: "",

  option_1: "",
  option_2: "",
  option_3: "",
  option_4: "",
  option_5: "",

  reason_1: "",
  reason_2: "",
  reason_3: "",
  reason_4: "",
  reason_5: "",

  job_user:"",
  job_date:"",
  des:"",
};

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const EvknRHellaSwagPage = (props: any) => {

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)

  const [evkn_detail_data, setEvkn_detail_data] = useState<any>(initailEvknData);

  const [page, setPage] = useState(1);
  const [c_page, setC_page] = useState("")
  const [order, setOrder] = useState('desc');
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [pagination, setPagination] = useState<pageInfoType | undefined>(undefined);

  const [evknWorkList, setEvknWorkList] = useState([]);

  const [isp_yn, setIsp_yn] = useState('모두');

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const updateEvknRHellaSwag = async (isp: any) => {

    setBackdrop(true)
    
    const formData = new FormData();

    formData.append("email", email);

    formData.append("worker", worker);

    formData.append("isp_yn", (isp === "일반상식" ? "Y" : isp));

    // if(isp === "일반상식") formData.append("new_category_cd", "201");

    const updatedColEvknData = {
      ...evknRHellaSwagData,
      reason_path: Array.isArray(reason_path) ? reason_path : (() => {
        try { return JSON.parse(reason_path as string); } catch { return []; }
      })(),
      options: Array.isArray(options) ? options : (() => {
        try { return JSON.parse(options as string); } catch { return []; }
      })(),
      isp_yn: isp,
      category_cd: (isp === "일반상식" ? "201" : evknRHellaSwagData.category_cd),
    };

    formData.append("evknRHellaSwagData", JSON.stringify(updatedColEvknData));

    await api.post("/updateEvknRHellaSwag",formData)
    .then((res:any) => {alert(updatedColEvknData.source_id + " 데이터 검수 완료"); setBackdrop(false); getEvknDataList(true);})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }

  const [evknRHellaSwagData, setEvknRHellaSwagData] = useState<any>([]);

  const [reason_path, setReason_path] = useState<any>([]);

  const reason_path_change = (idx: number, val: string) => {
    setReason_path((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const [options, setOptions] = useState<any>([]);
  
  const options_change = (idx: number, val: string) => {
    setOptions((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const handleAdd = () => setReason_path((prev) => [...prev, ""]);
  const handleRemove = (idx: number) =>
    setReason_path((prev) => prev.filter((_, i) => i !== idx));

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  const getEvknDataList = async (selectFirst: boolean = false) => {
    
    setBackdrop(true)
    api.get('/evknRHellaSwagDataList',{params:{email:email, worker:worker, page:page, order:order, isp_yn:isp_yn, idx:""}})
    .then((res:any) => {
      
      

      if(res.data.datas.length > 0){
        setEvknWorkList(res.data.datas);
        

        if (selectFirst) {
          // 호출 시 명시적으로 첫 번째 row 선택
          setEvknRHellaSwagData(res.data.datas[0]);
          setReason_path(JSON.parse(res.data.datas[0].reason_path));
          setOptions(JSON.parse(res.data.datas[0].options));
        }else if((evknRHellaSwagData && evknRHellaSwagData.idx == -1) || (pagination && page != pagination.current_page)){
          setEvknRHellaSwagData(res.data.datas[0])
          setReason_path(JSON.parse(res.data.datas[0].reason_path));
          setOptions(JSON.parse(res.data.datas[0].options));
        }
        setPagination(res.data.pagination)
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        setEvknWorkList(res.data.datas);
        setPagination(res.data.pagination)
        setTotal_cnt(0)
      }
      setBackdrop(false)
      })
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
  }

  useEffect(() => {
    getEvknDataList()
  }, [page, props.rowDetail]);
  
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // 입력 중일 때(텍스트 필드/텍스트에어리어 등)에는 핫키 동작 막기
      const target = e.target as HTMLElement;
      if (target) {
        const tagName = target.tagName;
        if (tagName === "INPUT" || tagName === "TEXTAREA" || (target as any).isContentEditable) {
          return;
        }
      }

      if (e.key === "1") {
        e.preventDefault();
        updateEvknRHellaSwag("Y");
      } else if (e.key === "0") {
        e.preventDefault();
        updateEvknRHellaSwag("P");
      } else if (e.key === "2") {
        e.preventDefault();
        updateEvknRHellaSwag("B");
      } else if (e.key === "7") {
        e.preventDefault();
        updateEvknRHellaSwag("일반상식");
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [evknRHellaSwagData]); // 현재 선택된 row 정보에 맞게 동작하도록 colEvknData 의존

  return (
    <Paper sx={{width:"100%", overflow: "auto"}}>
      {backdrop && ( <SearchBackDrop message={"처리중..."}/> )}
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>지식 - 데이터 검수(최종)</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">

        <EvalTextViewPage_204 sid={evknRHellaSwagData.source_id} />

        {/* simpleQA */}
        <Box display="flex">
          <Box sx={{width:"100%"}}>
            <Paper sx={{padding:"2px", border:"3px solid #3e36a5", backgroundColor:"#e4ffdc"}}>
              <Box sx={{margin:"4px"}}>
                <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                  <Box>
                    <Box display="flex" justifyContent="center">
                      <Box sx={{fontSize:"20px", fontWeight:700, textAlign:"center", margin:"2px"}}>EVKN_RHellaSwag</Box>
                      <Button variant="contained" size="small" sx={{marginLeft:"32px",fontWeight:700, backgroundColor:"#e79055"}} onClick={() => setOpenJsonDialog(true)}>
                        OPEN JSON
                      </Button>
                    </Box>
                    {openJsonDialog ? <EvalJsonDialog className="json-dialog-content" data={evknRHellaSwagData.prc_json} setOpenJsonDialog={setOpenJsonDialog} />:<></>}
                    
                    <Box display="flex" sx={{marginTop:"8px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류</Box>
                      <Select id="topic_cd" value={evknRHellaSwagData?.category_cd || ""} onChange={(e) => {setEvknRHellaSwagData({ ...evknRHellaSwagData, category_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"340px", height: "28px", marginLeft: "54px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={""}>선택하세요</MenuItem>
                        <MenuItem dense value={"101"}>한국형-역사</MenuItem>
                        <MenuItem dense value={"102"}>한국형-문화</MenuItem>
                        <MenuItem dense value={"103"}>한국형-사회</MenuItem>
                        <MenuItem dense value={"104"}>한국형-지리</MenuItem>
                        <MenuItem dense value={"105"}>한국형-언어</MenuItem>
                        <MenuItem dense value={"106"}>한국형-정치및법</MenuItem>
                        <MenuItem dense value={"201"}>글로벌-일반상식</MenuItem>
                        <MenuItem dense value={"202"}>글로벌-과학</MenuItem>
                        <MenuItem dense value={"203"}>글로벌-인문학및사회학</MenuItem>
                        <MenuItem dense value={"204"}>글로벌-공학및기술</MenuItem>
                        <MenuItem dense value={"205"}>글로벌-경제</MenuItem>
                        <MenuItem dense value={"206"}>글로벌-기타</MenuItem>
                      </Select>
                    </Box>
                    {/* <Box sx={{margin:"0px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question (난이도 : <b style={{fontSize:"14px", fontWeight:700, textAlign:"center", margin:"2px", color:(evknRHellaSwagData.difficulty === "H" ? "red":(evknRHellaSwagData.difficulty === "M" ? "#d7c200": "#00db45")) }}>{(evknRHellaSwagData.difficulty === "H" ? "High":(evknRHellaSwagData.difficulty === "M" ? "Medium": "Low"))}</b>)</Box>
                    <Box><textarea spellCheck="false" value={evknRHellaSwagData.question || ""} onChange={(e) => {setEvknRHellaSwagData({ ...evknRHellaSwagData, question: e.target.value });}} style={{border:"4px solid #000", width:"620px",minHeight:"140px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box> */}
                  </Box>
                </Box>
              </Box>

              <Box display="flex" sx={{marginTop:"8px"}}>
                  <Box>
                    <Box sx={{margin:"4px"}}>
                      <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                        <Box>
                          <Box sx={{margin:"0px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question (난이도 : <b style={{fontSize:"14px", fontWeight:700, textAlign:"center", margin:"2px", color:(evknRHellaSwagData.difficulty === "high" ? "red":(evknRHellaSwagData.difficulty === "medium" ? "#d7c200": "#00db45")) }}>{(evknRHellaSwagData.difficulty === "high" ? "High":(evknRHellaSwagData.difficulty === "medium" ? "Medium": "Low"))}</b>)</Box>
                          <Box><textarea spellCheck="false" value={evknRHellaSwagData.question || ""} onChange={(e) => {setEvknRHellaSwagData({ ...evknRHellaSwagData, question: e.target.value });}} style={{border:"4px solid #000", width:"440px",minHeight:"240px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
  
                    <Box sx={{width:"420px"}}>
                      <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                          <Box><textarea spellCheck="false" value={evknRHellaSwagData.answer || ""} onChange={(e) => {setEvknRHellaSwagData({ ...evknRHellaSwagData, answer: e.target.value });}} style={{border:"4px solid #000", width:"400px",minHeight:"16px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
  
                  </Box>
                  <Box>
                    <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                        {options && options.map((item:any, index:any) => 
                          <Box key={"Box_Options"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                            <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px", color:(evknRHellaSwagData.answer === String.fromCharCode(65 + index) ? "red" : "#000") }}>{String.fromCharCode(65 + index)}.</Box>
                            {/* <textarea key={index} readOnly={(evknRHellaSwagData.answer === String.fromCharCode(65 + index) && !["EVAL001","EVAL007"].includes(worker))} spellCheck="false" value={item || ""} onChange={(evknRHellaSwagData.answer !== String.fromCharCode(65 + index) || ["EVAL001","EVAL007"].includes(worker)) ? (e:any) => options_change(index, e.target.value) : undefined} style={{width:"340px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", backgroundColor:(evknRHellaSwagData.answer === String.fromCharCode(65 + index) ? "#f0ffea" : "#fff"), fontFamily: "Noto Sans KR"}}  /> */}
                            <textarea key={index} spellCheck="false" value={item || ""} onChange={(e:any) => options_change(index, e.target.value)} style={{width:"340px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", backgroundColor:(evknRHellaSwagData.answer === String.fromCharCode(65 + index) ? "#f0ffea" : "#fff"), fontFamily: "Noto Sans KR"}}  />

                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
              </Box>

              {/* <Box sx={{width:"420px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea spellCheck="false" value={evknRHellaSwagData.answer || ""} onChange={(e) => {setEvknRHellaSwagData({ ...evknRHellaSwagData, answer: e.target.value });}} style={{border:"4px solid #000", width:"620px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR" }}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                    {options && options.map((item:any, index:any) => 
                      <Box key={"Box_Options"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                        <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px", color:(evknRHellaSwagData.answer === String.fromCharCode(65 + index) ? "red" : "#000") }}>{String.fromCharCode(65 + index)}.</Box>
                        <textarea key={index} readOnly={evknRHellaSwagData.answer === String.fromCharCode(65 + index)} spellCheck="false" value={item || ""} onChange={evknRHellaSwagData.answer !== String.fromCharCode(65 + index) ? (e:any) => options_change(index, e.target.value) : undefined} style={{width:"280px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", backgroundColor:(evknRHellaSwagData.answer === String.fromCharCode(65 + index) ? "#f0ffea" : "#fff"), fontFamily: "Noto Sans KR"}}  />
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box> */}

              <Box sx={{width:"420px"}}>
                <Box sx={{margin:"8px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>topic_detail</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea readOnly={true} spellCheck="false" value={evknRHellaSwagData.topic_detail || ""} style={{width:"620px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR" }}  /></Box>
                  </Box>
                </Box>
              </Box>


              <Box sx={{width:"100%", marginTop: "16px"}}>
                <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#fff9c1"}}>
                  <Box sx={{margin:"4px 4px 4px 4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px", width:"420px"}}>
                        <Box sx={{fontSize:"24px", fontWeight:700, textAlign:"center", margin:"2px"}}>추론경로(CoT)</Box>
                      </Box>
                      <Box><Button sx={{backgroundColor:"#9169ff"}} variant="contained" onClick={handleAdd}>항목 추가</Button></Box>
                    </Box>
                  </Box>
  
                  <Box sx={{width:"750px",margin:"4px", height:"200px", overflow:"auto"}}>
                    <Box sx={{margin:"4px 0px 4px 2px", color:"#4664b4", fontWeight:700}}>Reason Path ({reason_path && reason_path.length})</Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                        {reason_path && reason_path.map((item:any, index:any) => 
                          <Box key={"Box"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                            <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px" }}>{index + 1}.</Box>
                            <textarea key={index} spellCheck="false" value={item || ""}  onChange={(e) => reason_path_change(index, e.target.value)} style={{width:"640px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  />
                            <DangerousRoundedIcon sx={{marginLeft:"8px"}} onClick={() => handleRemove(index)}>✕</DangerousRoundedIcon>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  
                  <Box display="flex">
                    {/* <Box sx={{display:"flex", marginTop:"16px"}}>
                      <Box sx={{display:"flex",marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                        <Box><textarea value={(evknRHellaSwagData.des === "None" ? "" : evknRHellaSwagData.des) || ""} onChange={(e) => {setEvknRHellaSwagData({ ...evknRHellaSwagData, des: e.target.value });}} style={{width:"360px",minHeight:"40px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box> */}
                    <Box sx={{display:"flex", marginTop:"16px"}}>
                      <Box sx={{display:"flex",marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                        <Box><textarea value={(evknRHellaSwagData.des === "None" ? "" : evknRHellaSwagData.des) || ""} onChange={(e) => {setEvknRHellaSwagData({ ...evknRHellaSwagData, des: e.target.value });}} style={{width:"300px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box>
                      <Box sx={{width:"100%", marginTop: "8px"}}>
                        <Box display="flex" justifyContent="center">
                          <Button variant="contained" color="primary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                            onClick={() => {
                              updateEvknRHellaSwag('Y');
                            }}
                          >
                            O (선정)
                          </Button>
                        </Box>
                      </Box>
                      <Box sx={{width:"100%", marginTop: "8px"}}>
                        <Box display="flex" justifyContent="center">
                          <Button variant="contained" color="secondary" sx={{fontSize:"24px", backgroundColor:"#d39e4f", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                            onClick={() => {
                              updateEvknRHellaSwag('B');
                            }}
                          >
                            △ (보류)
                          </Button>
                        </Box>
                      </Box>
                      <Box sx={{width:"100%", marginTop: "8px"}}>
                        <Box display="flex" justifyContent="center">
                          <Button variant="contained" color="secondary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                            onClick={() => {
                              updateEvknRHellaSwag('P');
                            }}
                          >
                            X
                          </Button>
                        </Box>
                      </Box>
                  </Box>
                  
                </Paper>
              </Box>
              
            </Paper>
          </Box>
        </Box>
        {/* simpleQA */}

        {/* 작업 리스트 */}
        <Box>
        {/* Task 단위 화면 */}
        <Box display="flex" justifyContent="center" >
          <Box sx={{padding:"4px 8px 8px 8px", width:"368px"}}>
            <Box display="flex">
              <Box><img style={{width:"24px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} /></Box>
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>작업목록</Box>
            </Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>검수</Box></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {(evknWorkList != undefined && evknWorkList.length > 0) ? evknWorkList.map((row:any, index:number) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(evknRHellaSwagData != undefined && row.idx === evknRHellaSwagData.idx ? "#dbdbef": "#fff")}}
                    onClick={()=> {setEvknRHellaSwagData(row); setReason_path(JSON.parse(row.reason_path)); setOptions(JSON.parse(row.options));}}
                  >
                    <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.isp_yn === "Y" ? "2px solid #27cc2f" : (row.isp_yn === "P" ? "2px solid #7427cc" : (row.isp_yn === "B" ? "2px solid #d39e4f" : "#000"))), color:"#000" }}>
                        {(row.isp_yn === "Y" ? "완료" : (row.isp_yn === "P" ? "X" : (row.isp_yn === "B" ? "보류" : "미작업")))}
                      </Box>
                    </TableCell>
                  </TableRow>
                  )):<TableRow><TableCell colSpan={2} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{marginTop:"12px"}}>
              {pagination !== undefined ? (
                  <>
                  <CustomPagination pagination={pagination} goPage={goPage} />
                  <Box display="flex">
                  <TextField size="small" id="worker" value={c_page} onChange={(e)=>setC_page(e.target.value)} 
                    sx={{width:"60px",height: "23px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} 
                    InputProps={{
                      style: {width: "60px", height:"23px", fontSize:"12px"},
                      inputProps: { 
                        spellCheck: "false" // spellcheck를 false로 설정
                      },
                    }}
                    />
                    <Button variant="contained" sx={{marginLeft:"8px",minWidth: "58px", height:"30px", fontSize:"12px"}} onClick={()=>setPage(Number(c_page))}>
                      이동
                    </Button>
                  </Box>
                  </>
              ) : ""}
            </Box>
          </Box>
          
          
        </Box>
      </Box>
            
      </Box>

    </Paper>
  );
  
  
};

export default EvknRHellaSwagPage;
